import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import TextFieldExt from "@entrilia/shared/components/inputs/TextFieldExt";
import { combineValidators, minCharactersValidator, requiredValidator } from "@entrilia/shared/utilities/validators";
import type { MeasureDescriptor } from "../../../../../../../../api/types/svTypes.ts";
import { selectMeasures } from "../../../../store/selectors/metaDataSelectors";
import { sanitizeFieldName } from "../utilities/sanitizeFieldName.ts";
import type { CustomMeasureReturnType } from "./hooks/useCustomMeasure";
import { duplicateMeasureNameValidator } from "./utilities/duplicateMeasureNameValidator";

interface Props {
  measure?: MeasureDescriptor;
  state: CustomMeasureReturnType;
  onError: (error?: string) => void;
}

export const NameField = ({ measure, state, onError }: Props) => {
  const measures = useSelector(selectMeasures);
  const validateName = combineValidators(
    requiredValidator,
    minCharactersValidator(3),
    duplicateMeasureNameValidator(measures, measure?.name)
  );

  return (
    <Grid container sx={{ width: "100%" }}>
      <TextFieldExt
        name="name"
        textFieldProps={{
          size: "small",
          label: "Name",
          variant: "outlined",
          value: state.caption,
          sx: { flex: 1 },
          placeholder: "Set Name...",
        }}
        doValidate={(value) => validateName(sanitizeFieldName(value))}
        onValidated={(_, result) => (result.isValid ? onError() : onError("invalid name"))}
        onValueChanged={(value) => state.actions.updateCaption(value)}
      />
    </Grid>
  );
};

export default NameField;
